<template>
<div class="col-12">
<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <a class="navbar-brand" href="#">Navbar</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li v-for="(nav, navIndex) in navData" :key="navIndex">
          <a v-if="nav.child.length !== 0" class="nav-link dropdown-toggle" href="#" :id="nav.title" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ nav.title }}
            <div v-if="nav.child.length > 0" class="dropdown-menu" :aria-labelledby="nav.title">
                <router-link v-for="(child, index) in nav.child" :key="index" :to="{ name: child.url }" class="dropdown-item" ><i :class="child.icon"></i> {{ child.title }}</router-link>
            </div>
          </a>
          <a v-if="nav.child.length === 0" class="nav-link" href="#">{{ nav.title }}</a>
      </li>
      <li>
          <router-link to="" class="nav-link" @click.native="logout">Logout</router-link>
      </li>
    </ul>
  </div>
</nav>
</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      navData: [
        {
          isNav: true,
          title: 'Dashboard',
          url: 'appDashboard',
          icon: 'fas fa-chart-line',
          child: []
        },
        {
          isHeader: true,
          title: 'Transaksi',
          child: [
              {
                isNav: true,
                title: 'Order Pembelian',
                url: 'appPO',
                icon: 'fas fa-shopping-cart'
                },
                {
                isNav: true,
                title: 'Faktur Pembelian',
                url: 'appPI',
                icon: 'fas fa-receipt'
                },
                {
                isNav: true,
                title: 'Retur Pembelian',
                url: 'appPurchaseReturn',
                icon: 'fas fa-exchange-alt'
                },
                {
                isDivider: true
                },
                {
                isNav: true,
                title: 'Faktur Penjualan',
                url: 'appSI',
                icon: 'fas fa-hand-holding-usd'
                },
                {
                isDivider: true
                },
                {
                isNav: true,
                title: 'Penerimaan Barang',
                url: 'appProductReceive',
                icon: 'fas fa-warehouse'
                },
          ]
        },
        {
          isHeader: true,
          title: 'Master',
          child: [
              {
          isNav: true,
          title: 'Pemasok',
          url: 'appVendor',
          icon: 'far fa-user-circle'
        },
        {
          isNav: true,
          title: 'Merek Produk',
          url: 'appBrand',
          icon: 'fas fa-star-of-life'
        },
        {
          isNav: true,
          title: 'Produk',
          url: 'appProduct',
          icon: 'fab fa-product-hunt'
        },
        {
          isNav: true,
          title: 'Servis',
          url: 'appService',
          icon: 'fab fa-servicestack'
        },
        {
          isNav: true,
          title: 'Servis Produk',
          url: 'appProductService',
          icon: 'far fa-list-alt'
        },
        {
          isNav: true,
          title: 'Tipe Produk',
          url: 'appProductType',
          icon: 'fas fa-filter'
        },
        {
          isNav: true,
          title: 'Katalog Harga',
          url: 'appValidateUser',
          icon: 'fas fa-donate'
        },
        {
          isNav: true,
          title: 'Kendaraan',
          url: 'appVehicle',
          icon: 'fas fa-car'
        },
        {
          isNav: true,
          title: 'Merek Kendaraan',
          url: 'appVehicleBrand',
          icon: 'fas fa-medal'
        },
          ]
        },
        {
          isHeader: true,
          title: 'Laporan',
          child: [
              {
                isNav: true,
                title: 'Order Pembelian',
                url: 'appRptPurchaseOrder',
                icon: 'fas fa-chart-pie'
                },
                {
                isNav: true,
                title: 'Sisa Order Pembelian',
                url: 'appRptOutstandingPO',
                icon: 'fas fa-project-diagram'
                },
                {
                isNav: true,
                title: 'Faktur Pembelian',
                url: 'appRptPurchaseInvoice',
                icon: 'fas fa-stream'
                },
                {
                isNav: true,
                title: 'Ringkasan Penjualan',
                url: 'appRptSales',
                icon: 'fas fa-dollar-sign'
                },
                {
                isNav: true,
                title: 'Mutasi Persediaan',
                url: 'appRptInventoryMutation',
                icon: 'fas fa-truck-loading'
                },
                {
                isNav: true,
                title: 'Penilaian Persediaan',
                url: 'appRptInventoryValuation',
                icon: 'fas fa-chart-area'
                },
                {
                isNav: true,
                title: 'Omset dan Laba',
                url: 'appRptProfit',
                icon: 'far fa-money-bill-alt'
                },
          ]
        },
        {
          isHeader: true,
          title: 'Publik (Apps)',
          child: [
              {
                isNav: true,
                title: 'Artikel',
                url: 'appArticle',
                icon: 'far fa-newspaper'
                },
                {
                isNav: true,
                title: 'Promo',
                url: 'appPromotion',
                icon: 'fas fa-ad'
                },
                {
                isNav: true,
                title: 'Pengaturan User',
                url: 'appUser',
                icon: 'fas fa-user-plus'
                },
                {
                isNav: true,
                title: 'Pengaturan Member',
                url: 'appMember',
                icon: 'fas fa-user-circle'
                },
                {
                isNav: true,
                title: 'Produk (Apps)',
                url: 'appProductApps',
                icon: 'fas fa-suitcase-rolling'
                },
                {
                isNav: true,
                title: 'Servis (Apps)',
                url: 'appServiceApps',
                icon: 'fas fa-toolbox'
                },
                {
                isNav: true,
                title: 'Servis Order (Apps)',
                url: 'appServiceOrder',
                icon: 'fas fa-wallet'
                },
          ]
        },
      ]
    }
  },
  methods: {
    ...mapActions(['appLogout']),
    renderActiveLink(routeName) {
      return (this.$route.name === routeName) ? 'active' : ''
    },
    logout() {
      this.appLogout()
      this.$router.push({ name: 'appLogin' })
    }
  }
}
</script>